// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2t69m","error":"Textarea_error__dmzuP","readonly":"Textarea_readonly__2nv0B","disabled":"Textarea_disabled__3TtWy"};